<template>
  <main @keypress.enter="send">
    <h1>Registrace na RangerCamp</h1>
    <input type="text" v-model="email" placeholder="E-mail" />
    <input type="password" v-model="password" placeholder="Heslo" />
    <button @click="send">Přihlásit</button>
  </main>
</template>

<script>
export default {
  name: "login",
  data: () => ({
    email: "",
    password: ""
  }),
  methods: {
    send() {
      this.$store.dispatch("login", {
        email: this.email,
        password: this.password
      });
    }
  }
};
</script>

<style lang="sass">
@import '../sass/_components'
@import '../sass/_constants'

#app.login
  display: grid
  grid-template-rows: auto 1fr
  align-items: center
  justify-items: center
  main
    display: grid
    margin: 1rem
    min-width: 20%
    grid-row-gap: 10px

    font-size: 1.5rem
    h1
      text-align: center
      font-weight: bold
      font-size: 2rem
    input
      @include input-base()
    button
      @include button-primary()
      padding:
        left: 50px
        right: 50px
      justify-self: center
</style>